export const diagnosticTabHasTask = (tab, tasks) => {
  switch (tab) {
    case 'RAT':
      return tasks.hasRat;
    case 'INSECT':
      return tasks.hasInsect;
    case 'DISINFECTION':
      return tasks.hasDisinfection;
    case 'OTHER_PESTS':
      return tasks.hasOtherPests;
    case 'ANNEX_1':
      return tasks.hasAnnex1;
    case 'ANNEX_2':
      return tasks.hasAnnex2;
    default:
      return null;
  }
};



// WEBPACK FOOTER //
// ./src/modules/saas/pco/cases/form/utils/index.js